module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1525-a0a72e2a2e6d99a905f227988290d4e1.png";